/** @format */

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { IEnvironment } from '@shared/data-access/interfaces';
/** @format */
import { chain } from '@core/chain';

const imagesRoot = 'https://images.dickssportinggoods.com';
const spring_microService_breadcrumb = 'https://breadcrumbservice.iso.an01.pcf.dcsg.com/';
const spring_microService_category = 'https://categoryservice.iso.an01.pcf.dcsg.com/';
const spring_microService_recommendations =
  'https://ds-recs-details.preview.genextapps01.ue.p.aks.dcsg.com';

export const ceopsPaths = {
  local: 'http://localhost:6001',
  perf: 'https://ceops.dickssportinggoods.com/perf',
  QA: `https://prod-${chain.seoIdentifier}.dksxchange.com/ecomm-scripts`,
  preview: `https://preview.${chain.seoIdentifier}.com/ecomm-scripts`,
};

export const devEnvironmentDefaults: IEnvironment = {
  api: {
    homr: {
      proxy: {
        path: `/home/homr/v2/api/`,
        timeout: DCSG_CONSTANTS.homr.timeout,
      },
      baseDomain: {
        dsg: 'https://www.dickssportinggoods.com',
      },
      url: 'https://www.dickssportinggoods.com/dcsg-ngx-home/homr/v2/api/',
      scene7Url: 'https://dks.scene7.com/is/image/dksfed/',
      scene7UrlCDN: 'https://dks.scene7.com/is/image/dkscdn/',
    },
    aemFoundationDetails: {
      // to be updated as part of https://dcsgcloud.atlassian.net/browse/SPPJ-87
      proxy: {
        path: `/graphql/execute.json/ContentFragments/getFoundationDetailsList`,
        timeout: '15000',
      },
      url: 'https://publish-p42408-e166538.adobeaemcloud.com',
    },
    reactMarginals: {
      caliaHeaderUrl: 'https://static-search.dickssportinggoods.com/calia-navigation/perf',
      caliaFooterUrl: 'https://static-search.dickssportinggoods.com/calia-navigation/perf',
      headerUrl: 'https://static-search.dickssportinggoods.com/calia-navigation/perf',
      footerUrl: 'https://static-search.dickssportinggoods.com/calia-navigation/perf',
      footerHTMLId: 'responsive-footer',
      proxy: {
        path: `/marginals/`,
        timeout: 15000,
      },
    },
    spring: {
      microService: {
        breadcrumb: {
          AKSEast: spring_microService_breadcrumb,
          AKSWest: spring_microService_breadcrumb,
        },
        category: {
          AKSEast: spring_microService_category,
          AKSWest: spring_microService_category,
        },
        recommendations: {
          AKSEast: spring_microService_recommendations,
          AKSWest: spring_microService_recommendations,
        },
        seoservice: {
          AKSEast: 'https://seo-api.genextapps01.ue.qa.aks.dcsg.com/',
          AKSWest: 'https://seo-api.genextapps01.ue.qa.aks.dcsg.com/',
        },
        taxoservice: 'https://browse.dickssportinggoods.com/dcsg-ngx-category/taxo/api/',
      },
      microServiceProxy: {
        recommendations: {
          path: '/api/spring/msvc/ds/v1/',
          timeout: '15000',
        },
      },
    },
    dataScience: {
      basePath: '/api/spring/msvc/ds/v1/',
      target: spring_microService_recommendations,
    },
    esb: {
      gatewayUrl: 'https://gateway.dksxchange.com/',
      gatewayUrlProxy: {
        browser: '/dcsg-ngx-home/esb/api/',
        server: 'http://localhost/dcsg-ngx-home/esb/api/',
      },
    },
    ceops: ceopsPaths.perf,
    ecommScripts: ceopsPaths.QA,
    seo: 'https://api-search.dickssportinggoods.com/',
    criteo: {
      baseUrl: 'https://d.us.criteo.com/delivery/retailmedia?',
      nolog: 1,
      partnerId: {
        dsg: 25953,
        gg: 35855,
      },
    },
    brandify: {
      brandifyBaseUrl: 'https://hosted.where2getit.com/',
      proxy: {
        path: `/home/store/locator/`,
      },
    },
    kraken: {
      gatewayUrl: `https://kraken.genextapps01.ue.qa.aks.dcsg.com/`,
      gatewayUrlProxy: {
        path: `/home/kraken/api`,
      },
    },
  },
  images: {
    netstorage: {
      marketing: `${imagesRoot}/marketing/`,
      product: `${imagesRoot}/product/`,
    },
    scene7proxy: {
      marketing: `https://dks.scene7.com/is/image/dksfed/`,
      marketingContent: `https://dks.scene7.com/is/content/dksfed/`,
      product: `https://dks.scene7.com/is/image/dkscdn/`,
    },
  },
  thirdParty: {
    auth0: {
      dsg: {
        enabled: true,
      },
      gg: {
        enabled: true,
      },
      pl: {
        enabled: true,
      },
      g3: {
        enabled: false,
      },
      sm: {
        enabled: false,
      },
      plf: {
        enabled: false,
      },
    },
  },
  baseDomain: {
    dsg: 'https://meta.dickssportinggoods.com',
    gg: 'https://meta.golfgalaxy.com',
    pl: 'https://meta.dickssportinggoods.com',
    g3: 'https://meta.goinggoing.com',
    sm: 'https://beta.sportsmatter.org',
    plf: 'https://publiclandsfund.org',
  },
  identityServiceKey: {
    partnerKey: 'MyAccount',
    secretKey: '8uBj3x2Zi3usl4PTiTyi',
  },
  feature: {
    homRAudiences: {
      dsg: true,
      gg: true,
      pl: true,
      g3: true,
      sm: false,
      plf: false,
    },
  },
  solePanel: {
    iframeParent: '*',
    dsg: 'https://beta-solepanel-dks.dickssportinggoods.com',
    gg: 'https://solepanel-gg.dksxchange.com',
    pl: 'https://beta-solepanel-pl.dickssportinggoods.com',
  },
};
